module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page64"
    }
  }), _c('a', {
    attrs: {
      "id": "page65"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page65"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page65"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Germanness Emerging")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("O")])]), _vm._v("ne Sunday evening in the spring of 1747, as his court musicians were gathering for their regular concert, an aide handed Friedrich the Great, king of Prussia, a list of visitors who had arrived at the Potsdam town gate that day. When the king scanned the list, he suddenly cried out: “Gentlemen, old Bach is here!” Later accounts had it that there was “a kind of agitation” in the king’s tone."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n76",
      "id": "n76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Johann Sebastian Bach, the composer, then sixty-two, had journeyed from Leipzig, eighty miles away, to visit his son Carl, chief harpsichordist in Prussia’s royal Kapelle. Ever since Carl had been in Potsdam, the Prussian king had let it be known that he would like to meet “old Bach.” Carl, however, knew how different his father and the king were and had done nothing to bring them together. He was not wrong. The encounter, when it did occur, proved to be a collision between two very different worlds."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n77",
      "id": "n77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Bach was an orthodox Lutheran who believed the biblical tradition that music was Hebrew. He was a widower and a family man who had twenty children between his two wives. “Frederick, a bisexual misanthrope in a childless, political marriage,” says James Gaines in his description of the meeting, “was a lapsed Calvinist whose reputation for religious tolerance arose from the fact that he held all religions equally in contempt.” Bach wrote and spoke German. At the king’s celebrated court, everyone spoke French. Friedrich boasted he had “never read a German book.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n78",
      "id": "n78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page66"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page66"
    }
  }, [_vm._v("Their differences carried over into their tastes in music. Bach was the most brilliant exponent of church music, in particular the “learned counterpoint” of canon and fugue, an ancient craft that had evolved such sophistication that many musicians of the day thought of themselves as “custodians of a quasi-divine art.” Friedrich considered such claims over-blown. Counterpoint, to him, was old-fashioned. He dismissed music that, as he quipped, “smells of the church.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n79",
      "id": "n79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Despite their differences, when the king saw “old Bach’s” name on the arrivals list, he ordered that the composer be brought to the palace that very night, not even giving him a chance to change his clothes. When Bach arrived, weary after his trek, he was presented by the king with a long and complex musical motif and a request (except it wasn’t really a request) that the composer make a three-part fugue of it. Despite the hour, despite his weariness, Bach rose to the task, “with almost unimaginable ingenuity,” so much so that all the virtuosi in the king’s orchestra were “seized with astonishment.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n80",
      "id": "n80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Still Friedrich wasn’t done, perhaps even a little disappointed that old Bach had performed so well. He now asked the composer if he could rearrange the theme into a fugue for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("six")]), _vm._v(" voices. This was a hoop Bach wouldn’t jump through, not there and then anyway. He insisted he would work out the arrangement on paper and send it to Friedrich later on.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In July, two months after the evening at Potsdam, the proud Bach completed the six-part fugue and dispatched it. There is no evidence that Friedrich ever had the piece played but had he done so, the king—a subtle, astute man—would have been more than a little affronted. For this composition contained what one historian described as a “devastating attack on everything that Frederick stood for.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n81",
      "id": "n81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" In the first place, the music was deeply religious. Elsewhere it contained a subtle form of sarcasm, where the score was annotated with references to the king’s rising fortunes—though in practice the music descended into melancholy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n82",
      "id": "n82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Counterpoint and other forms of music that smelled of the church were interspersed throughout, all of which has allowed musicologists to conclude that, in the “Musical Offering,” Bach was having the last word—defying, chiding, even satirizing the king, reminding him that “there is a law higher than any king’s which is never changing and by which you and every one of us will be judged.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n83",
      "id": "n83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page67"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This entire exchange—subtle, clever, but pointed—epitomized the clash between two very different worlds, a clash that, in 1747, was sharper than ever. Three years later Bach was dead. The last great achievement of his life, completed during his final months, was the Mass in B Minor, one of the great masterpieces of Western music (“titanic” in the words of the critic Harold Schonberg), and one that Bach himself would never hear. With the Mass in B Minor and Bach’s death, a whole artistic, spiritual, cultural, and intellectual world was at an end. The baroque had essentially been the style of the Counter-Reformation church, and its aim, in the visual arts, as summed up by Cardinal Gabriele Paleotti in Rome, one of the great reformers of the Catholic Church, was “to set on fire the soul of her sons,” to place “a sumptuous spectacle before the eyes of the faithful,” and to make the church “the image of heaven on earth.” Bach’s aim in his music—although it was Protestant music—was much the same. Such an understanding, such an aesthetic, died with him.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("But if the baroque fire was cooling, new beliefs, new tempers, new ways of thinking were taking its place. Some of these innovations were fundamental, reconfigurations in thought that were as profound and as revolutionary as anything expressed for a thousand or even two thousand years. Many of the new ideas transformed Europe in its entirety, and North America too. Several, however, were specific to Germany or applied there more than anywhere else.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page67"
    }
  }, [_vm._v("Until the middle of the eighteenth century—1763—the German-speaking lands were, in the words of the Harvard historian Steven Ozment, “Europe’s stomping ground.” Their location, at the geographical heart of Europe, had made them a crossroads of international trade since the Middle Ages, a circumstance not entirely without its beneficial effects. In the early sixteenth century, for example, the imperial free cities of Germany—Augsburg, Ulm, Cologne, Hamburg, Bremen, Lübeck—boasted a civic culture second only to their Italian and Swiss counterparts. At that time, Nuremberg, as Tim Blanning has pointed out, was home to Albrecht Dürer, Veit Stoss, Adam Krafft, Peter Vischer, and Hans Sachs. In the seventeenth century, however, that same geographical centrality conspired to make the German lands, as Ozment’s phrase implies, a battlefield for Europe’s great powers—France, Russia, Sweden, the Hapsburgs of Austria-")]), _c('a', {
    attrs: {
      "id": "page68"
    }
  }, [_vm._v("Hungary, and Britain. The Thirty Years’ War (1618–48), a bitter conflict between Catholics and Protestants, was fought largely on German territory, and was so vicious that atrocity stories became commonplace—see, for example, Philip Vincent’s contemporaneous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lamentations of Germany")]), _vm._v(", which featured plates showing “Croats eating children,” “Noses and Eares cut off to make Hatbandes,” and other delicacies. At the end of that time, the Treaty of Westphalia—a peace of exhaustion as much as anything else—hammered out a new political reality, a loose confederation of states of very unequal size and importance: 7 (later 9) electors (a reference to the office, largely ceremonial, of electing the emperor and his heir apparent, the king of the Romans), 94 spiritual and temporal princes, 103 counts, 40 prelates, 51 free cities, all equally sovereign (or half-sovereign), and around 1,000 knights, all claiming authority but ruling collectively barely 200,000 subjects."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n84",
      "id": "n84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" The main innovation among this morass was the fact that sovereign (and mainly Protestant) German states “spun away” one by one from their former historical hub, the Catholic Austrian/Hapsburg Empire. By using their new territorial rights, which gave them an independent foreign policy and armaments, Bavaria, Brandenburg-Prussia, Saxony, and Württemberg emerged from the Austrian shadow (though only Brandenburg-Prussia had a professional army worth the name)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n85",
      "id": "n85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" In 1667, Samuel Pufendorf, a jurist and the very man who coined the phrase “the Thirty Years’ War,” described what had been the former empire as a political and constitutional “monstrosity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n86",
      "id": "n86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Population had collapsed, Württemburg’s falling, as an example, from 445,000 in 1622 to 97,000 in 1639. The German states were now so fragmented that in the 1690s barges navigating the Rhine to the Channel paid border tolls on average every six miles."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n87",
      "id": "n87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Trade patterns had shifted to the North Atlantic following the voyages of discovery, and the German economy withered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This new world didn’t endure. Over the next 200 years, the single most important political, cultural, and social development in central Europe was the rise of Brandenburg-Prussia, the cell from which what followed emanated. In 1700 Hapsburg Austria was 9 million strong and still the preeminent part of the “Heiliges Römisches Reich deutscher Nation” (Holy Roman Empire of the German Nation). Prussia at the time could boast a population of barely 3 million and, in terms of territory, ranked only eleventh in Europe. Yet, by the middle of the eighteenth century it "), _c('a', {
    attrs: {
      "id": "page69"
    }
  }, [_vm._v("boasted Europe’s third-strongest army and was breathing down Austria’s neck."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n88",
      "id": "n88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" The root cause of this change owed something to the Peace of Westphalia because under it Brandenburg-Prussia had acquired the territories of East Pomerania, Magdeburg, Minden, and Silesia. Prussia’s successes also owed something to a line of rulers who lived long and productive lives. But the most important development, the development that came to shape and characterize Prussia, in her own eyes as well as in the eyes of others, was a new variety of the Christian religion. Germanness, as we now understand it, emerged in the late seventeenth and early eighteenth centuries and cannot be understood without a firm grasp of Pietism.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IETISM AND")]), _vm._v(" P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RUSSIANISM")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Friedrich the Great has, with good reason, attracted most attention from historians as a forceful personality who, by a combination of military prowess, personal charisma, and an intellectual/artistic cast of mind, helped catalyze the German renaissance that is the subject of the next few chapters. There is no doubt that he played an important role. Recent scholarship, however, has focused rather more on his father, Friedrich Wilhelm I. Without the achievements of this man, and the reforms he initiated, Friedrich the Great might not have had quite the glittering career that he did have.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("When Friedrich came to power in 1740, aged twenty-eight, what gave the Prussian state the special character "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("it already had")]), _vm._v(" was the unparalleled emphasis among state employees on the conscientious fulfillment of their official duties. “Whereas in other European capitals monarchs reigned over court establishments characterised by ostentatious luxury, the Prussian kings wore military uniforms and promoted an official ethic of parsimony and frugality.” The Prussian bureaucracy was even then well known for its commitment to much higher standards of honesty and efficiency than its European counterparts."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n89",
      "id": "n89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In the 1950s the German historian Carl Hinrichs advanced the thesis that the source of the Prussian state-service ideology can best be understood as the fruit of the Pietist movement, and he highlighted several significant connections between Pietism and the major policy initiatives introduced by Friedrich Wilhelm I. Hinrichs’s central book on the "), _c('a', {
    attrs: {
      "id": "page70"
    }
  }, [_vm._v("subject, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Preussentum und Pietismus")]), _vm._v(", was released only after his death and comprised a series of essays rather than a fully evolved thesis. These shortcomings have recently been addressed by Richard Gawthrop, whose arguments I have adapted in what follows."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n90",
      "id": "n90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Pietism first appeared around 1670, when its strong emphasis on discipline began to attract adherents who formed the view that Martin Luther’s church had itself become infected with the very corruptions it had been founded to avoid. These early Pietists sought a return to Luther’s “pristine simplicity” by “stressing the priesthood of all believers against the hierarchy, the inner light against doctrinal authority, the religion of the heart against the religion of the head…and practical acts of charity, not scholastic dispute.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n91",
      "id": "n91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" It should be said that there were other reasons that made Pietism attractive, especially to the political authorities. Chief among them was the fact that, in emphasizing the “inner light,” the Reformed churches, which had emerged after the 1648 Treaty of Westphalia, when the Papacy had lost a great deal of its worldly power, were much less of a political threat than the older, more orthodox, and more organized churches. The change to a more “internal” faith enabled the authorities to use the confessional as a way to impose a stricter moral discipline on the laity. The aims of Pietism and Friedrich Wilhelm coincided.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Pietism was deeply influenced by English Puritanism, notable for its “intrusive moralism,” advocating that good works "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in this life")]), _vm._v(", right here on earth, helped to determine what happened at the day of judgment. God, argued the Puritans, actually "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wanted")]), _vm._v(" people to perform good works here on earth—this was how He revealed himself. Friedrich Wilhelm was not formally a Pietist, but had grown up with a sensibility and work ethic not too dissimilar from that of the Pietists. Between 1713 and 1740, as a result of this complementarity of outlook, the king gave the Pietists unprecedented opportunities for realizing their ambitions, and these reinforced and helped legitimate the king’s fundamental restructuring of the administrative, military, and economic life of his realm. Thomas Nipperdey thought this had another effect: Protestantism was essentially pessimistic about human nature; this made it conservative and set against modernity. Such an attitude was to have momentous consequences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n92",
      "id": "n92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The first person who had called attention to the new approach was "), _c('a', {
    attrs: {
      "id": "page71"
    }
  }, [_vm._v("Philipp Jacob Spener, born in Alsace in 1635, in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pia Desideria")]), _vm._v(", published in 1685."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n93",
      "id": "n93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" But it was August Hermann Francke (1663–1727) who conceived the form of Pietism that was to transform Prussia. In the 1690s Spener induced the powers that be in Berlin to appoint Pietists to two professorships on the theological faculty of the newly established University of Halle. In the eighteenth century, the University of Halle, together with the University of Göttingen, would transform ideas about learning and scholarship in Germany (and eventually across the world). Francke, born in Lübeck, had been barred from teaching in Leipzig and joined the Halle faculty as professor of Near Eastern (then called Oriental) languages and, from 1695, this gave him the position and opportunity to rethink the state’s role in the light of Pietist aims."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n94",
      "id": "n94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("His own earlier crisis of faith, and a “born-again” conversion, convinced him that “the cultivation of the heart,” prayer, Bible reading, heartfelt repentance, and daily introspection were the basic ingredients for a truly religious life, rather than intellectual sophistication and doctrinal wrangling. He insisted that piety was not to be sought in isolation: to fulfill the biblical injunction to love one’s neighbor, “one should seek to improve society through practical acts of charity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n95",
      "id": "n95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" It was a short step to Francke’s view that vocational labor must become the main sphere of activity through which Pietists could serve their fellow citizens."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n96",
      "id": "n96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Theologically, Francke’s approach was quite daring: he justified such activism by arguing that the Creation “could be improved upon,” moreover that this improvement must form the central plank in the individual’s quest for salvation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n97",
      "id": "n97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Francke’s vision evolved in what we might call the long wake of the Thirty Years’ War. Doubt was, if not yet widespread, certainly growing."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n98",
      "id": "n98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" This helps explain why the main feature of his educational regime was strict—very strict—supervision, designed to inculcate in the pupil a habit of asceticism and unquestioning obedience to God’s authority. At the same time, Francke emphasized education in the more worldly, practical disciplines, so that pupils from Pietist schools could “produce something useful for their neighbours.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n99",
      "id": "n99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" The institution primarily responsible for these reforms was to be the clergy, which Francke now reconceived as the “teaching estate.” Networks of Halle graduates found their way to most north German cities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n100",
      "id": "n100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page72"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NTELLECTUAL")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENTRALIZATION AND A")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EW")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OLLECTIVE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENTALITY")])])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page72"
    }
  }, [_vm._v("This was the state of educational/pedagogical affairs when Friedrich Wilhelm I became king in 1713. He had undergone his own conversion in 1708, producing in him a vision not unlike Francke’s. On his accession, he lost no time in becoming the chief patron of theology graduates from Halle, as he aligned the forces of Halle Pietism with his own priorities."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n101",
      "id": "n101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In order to ensure this the king needed to mobilize not just the churches and the schools but the entire state apparatus, every socializing institution in Prussia. In this way was conceived “State Pietism.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n102",
      "id": "n102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" To help encourage it, in 1729 Friedrich Wilhelm decreed that all Lutheran pastors in his realm must have studied at the University of Halle for at least two years, a remarkable act of intellectual centralization. In 1725 Abraham Wolff and Georg Friedrich Rogall, important Halle Pietists, were made professors of theology at the University of Königsberg. The resulting influx of Pietists changed forever the character of the church in northeastern Germany."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n103",
      "id": "n103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("But it was in the military and in the bureaucracy that Pietist influence was most far-reaching. The military church was reorganized in 1718 and eventually more than 100 Pietist pastors were employed among the regiments."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n104",
      "id": "n104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Encountering ignorance on a massive scale, the pastors taught reading and writing to soldiers and their wives, at the same time introducing them to the Bible and through that to Pietist beliefs and values. The military church also educated the soldiers’ children—hundreds of regimental schools were built in the 1720s. (To facilitate matters, Friedrich Wilhelm ordered chaplains not to confirm anyone who could not read.)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n105",
      "id": "n105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" The very concept of honor ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ehre")]), _vm._v(") was itself transformed. Honor was no longer only a reflection of distinction in purely military matters: it now became necessary for an officer to fulfill his duty to others more widely—as a quartermaster, say, as a drillmaster, even as an accountant. What mattered was how much an officer had helped his neighbors, albeit subordinates.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The same culture permeated the bureaucracy. Following the Thirty Years’ War, the local princes, newly independent, required more money to maintain their courtly life on the French model, and this meant there "), _c('a', {
    attrs: {
      "id": "page73"
    }
  }, [_vm._v("was a demand for a relatively efficient bureaucracy to administer princely affairs efficiently."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n106",
      "id": "n106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beamtenstand")]), _vm._v(", the “estate of bureaucrats,” became established in the German lands, and in 1693 examinations were introduced for admission to the upper reaches of the judicial system. Then in 1727, the king created two professorships in cameralist studies, one at the University of Halle and the other at Frankfurt an der Oder. They were the first such professors in the history of German universities, and the lectures offered covered the technical and legal side of the Prussian state’s economic, finance, and police systems. As Hans Rosenberg put it in his 1958 book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Prussian Experience")]), _vm._v(", the three dominant elements were bureaucracy, aristocracy, and autocracy. At the same time, the king was a strong promoter of meritocracy, continually underlining the opportunities for lowly clerks to attain the highest level of tax commissar or departmental head."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n107",
      "id": "n107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" In this milieu, the bureaucrat became an advocate of a militant ideology dedicated to raising the level of civilian society through education. By 1742, a royal commission reported that no fewer than 1,660 schools had been built or repaired. (This shouldn’t be exaggerated, however. Schooling for everyone was not established until the mid-nineteenth century.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("No less important, over time the educational improvements brought about by Friedrich Wilhelm I and the Pietists created an entirely new collective mentality: in the words of Walter Dorn, the Prussians became “the most highly disciplined people of modern Europe.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n108",
      "id": "n108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Friedrich the Great had the good sense to keep this military-bureaucratic-educational-economic structure intact. By his death in 1786, State Pietism was the core of the culture. It would prove stable enough to survive the depredations of Napoleon—Stefan Zweig wrote approvingly of it a hundred years later.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ISE OF THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NIVERSITY")]), _vm._v(": “T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("REAT")]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("URN IN")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERMAN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IFE”")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Together with the Beamtenstand, the Prussian universities combined to give Germany another distinction all its own: a special kind of intelligentsia that was to have long-term consequences. The eighteenth-century German universities differed from the British ones in a number of important ways. In the first place, early eighteenth-century Germany had "), _c('a', {
    attrs: {
      "id": "page74"
    }
  }, [_vm._v("far more universities—about fifty, as compared with, for example, just Oxford and Cambridge in England. Although many were small (Rostock, with some 500 students when it was founded in 1419, now had only seventy-four students, while Paderborn had forty-five), their number and local character meant that it was much easier in Germany for the gifted sons from poorer families to obtain higher education."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n109",
      "id": "n109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("At the turn of the eighteenth century, however, teaching methods were backward. The norm was the teaching of static truths, not new ideas; professors were not expected to produce new knowledge, and the arts and philosophical faculties in particular had deteriorated. In many of the Catholic universities, theology and philosophy were the only subjects offered. Moreover, they were under threat from the new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ritterakademien")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ritter")]), _vm._v(" means “knight”), intended for the well-born, which offered a more fashionable curriculum that stressed mathematics, modern languages, social graces, the martial arts, and a smattering of science—worldly breadth rather than scholastic depth. What scientific research there was tended to be carried out in the new royal academies of science (such academies, on the French model, were founded in Berlin in 1700, Göttingen in 1742, and Munich in 1759). The German universities were, moreover, at the disposal of the princes, theirs to command for secular (i.e., very practical) purposes; they were not self-governing communities of scholars devoted to the study of classics and mathematics as were Oxford and Cambridge."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n110",
      "id": "n110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Paradoxically, however, although many people around 1700 regarded the universities in Germany as irrelevant and moribund, at the end of the seventeenth and during the first half of the eighteenth century, four new universities were opened that would transform the intellectual climate in Germany. These were Halle in Prussia (1694), Breslau in Silesia (1702), Göttingen in Hanover (1737), and Erlangen in the Frankish margravate of Bayreuth (1743). Heidelberg was also important but, founded in 1386, it was hardly new.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The University of Göttingen was to have more of an impact than any other except Halle. The leading figure in the establishment of Göttingen was Gerlach Adolf von Münchhausen."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n111",
      "id": "n111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Born in 1688, he studied abroad in Utrecht and subsequently took a grand tour in Italy; it was the necessity to leave Germany to acquire “polish” that struck him as unfortunate and produced in him the desire for university reform. When he became a "), _c('a', {
    attrs: {
      "id": "page75"
    }
  }, [_vm._v("member of the Hanover Privy Council in 1728, he began agitating for the foundation of a university there and was so successful that he was himself appointed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kurator")]), _vm._v(" of the new institution. He soon introduced several innovations that were to prove influential."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n112",
      "id": "n112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In the first place, Münchhausen ensured that theology played a relatively quiet role. Göttingen became the first university to restrict the theological faculty’s traditional right of censorship and, as Thomas Howard says in his study of German universities, “It is hard to overstate the historical importance of this measure.” As a direct result, the confessional age ended for the universities. Götz von Selle was just one who characterized this measure as “the pivot for the great turn in German life, which moved its centre of gravity from religion to the state.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n113",
      "id": "n113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" By this enlightened measure, Göttingen’s freedom to think, write, and publish became unparalleled in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Crucially, Münchhausen changed the relative weight enjoyed by the theology and philosophy faculties. Traditionally, philosophy was a distinctly inferior discipline, for both professors and students it was an “ante-chamber” to the higher faculties. Münchhausen added to the weight and importance of the “philosophical” subjects—such as history, languages, and mathematics—by his insistence that these fields were more than remedial areas for poorly prepared students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n114",
      "id": "n114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Eventually, the philosophical faculty at Göttingen offered, in addition to the traditional subjects of logic, metaphysics, and ethics, lectures on “empirical psychology,” the law of nature, physics, politics, natural history, pure and applied mathematics (surveying, military, and civilian architecture), history, geography, art, and modern languages. On top of these “philosophical” subjects, Göttingen offered the best training in the courtly arts available at any European institution—dancing, fencing, drawing, riding, music, and conversation in foreign languages."), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_4",
      "id": "footnote4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" Observers noted the new desire among young nobles to acquire a university education and a preference for “study and scholarship,” which could pave the way for “important posts.” It was at Göttingen that history, philology, and antiquity ceased to be minor, subordinate fields of study and began to acquire respect as autonomous "), _c('a', {
    attrs: {
      "id": "page76"
    }
  }, [_vm._v("disciplines. Alongside history, classical philology underwent a dramatic rise at Göttingen, and it and its sister discipline—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Altertumswissenschaft")]), _vm._v(", the study of antiquity—became the “German science” par excellence."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n115",
      "id": "n115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" Johann Matthias Gesner (1691–1761) and his successor, Christian Gottlob Heyne (1729–1812), transformed the experience of the classics. They removed the emphasis on grammar, replacing it with the appreciation of the texts as examples of the creative energies of antiquity; in so doing, the purpose of the new scholarship was transformed into an evaluation of the classics for what they revealed about culture, civic life, religion. “Above all, Greek antiquity—hitherto neglected—became "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the")]), _vm._v(" central focus.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n116",
      "id": "n116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Other innovations at Göttingen included publication of the first professional journals."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n117",
      "id": "n117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Göttingen also developed and refined the seminar. This was another innovation whose importance it is difficult to exaggerate. The seminar, as we shall see, led to the modern concept of research, to the modern PhD, to the academic and scientific “disciplines” or subjects, and to the modern organization of universities into “departments,” divided equally between teaching and research. Originally introduced in Halle by Francke, the seminar differed in important ways from the lecture, reflecting a profound change in the concept of knowledge and learning. The crucial distinction was that between late medieval notions of knowledge, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scientia")]), _vm._v(", and the post-Enlightenment idea of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wissenschaft")]), _vm._v(". Scholastic-Aristotelian logic took it as read that there was/is a single, correct method of thinking, a method that, when properly employed—through syllogistic reasoning, disputation, correct definition of terms, and “the clear ordering of arguments”—could be applied to any scholarly subject."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n118",
      "id": "n118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Different areas of interest did not require different methods, for all could be approached and understood through right reason ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("recta ratio")]), _vm._v("), apprehended through the study of logic. The main purpose of instruction in the lecture was to help the student acquire general reason.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In the seminar, however, there were fewer people, criticism was encouraged, knowledge was regarded as mutable, less fixed, and new knowledge was there to be discovered. The aim of the teachers in the seminar was not to reproduce “static knowledge” but to promote the “taste, judgement and intellect” of their charges.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Seminars evolved over time. They embodied a more intimate form of "), _c('a', {
    attrs: {
      "id": "page77"
    }
  }, [_vm._v("teaching, where the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exchange")]), _vm._v(" of ideas and knowledge was more valued, where the students were expected to have more input. Gradually, the passive mastery of a canonically prescribed corpus of materials gave way to the active cultivation of participation, and the early seminars in Germany began to require the submission of written work beforehand as a basis for discussion and evaluation."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n119",
      "id": "n119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" This fostered the concept of research, with a premium on originality, which—again as we shall see in more detail later—reached its apogee in the Romantic period, when original research was regarded as a form of art. In some Göttingen seminars, the practice evolved whereby the original paper had to be delivered a week in advance so that other students could prepare their responses.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In line with all this, it was at Göttingen, in the late eighteenth and early nineteenth centuries, that the term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wissenschaft")]), _vm._v(" first gained its modern meaning. In its Göttingen sense, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wissenschaft")]), _vm._v(" incorporates science, learning, knowledge, scholarship, and also implies a research-based element, an idea that knowledge is a dynamic process, discoverable "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("for oneself")]), _vm._v(", rather than something that is handed down."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n120",
      "id": "n120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" The practice of written submissions for the seminars—organized along the lines of the new scientific disciplines then emerging—led to the distinction between dissertation and thesis, and to the degree of PhD. The dissertation was essentially a display of erudition (a student would be asked to locate and assemble all known fragments of this or that minor classical author), whereas a thesis was a piece of research testing or leading to a hypothesis. The PhD eventually became a recognized degree in the German civil service and from this time on, its ascendancy—which again we shall examine in more detail later—was assured."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n121",
      "id": "n121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The development of the seminar and the transformation of the PhD went hand in hand with the evolution of classical and philological disciplines and biblical criticism, and so had an even bigger impact than all this implies. The neohumanism that these developments promoted helped to redefine the image of the educated man, changing it from the rather external one of the first university reform movement (at Halle, under Francke) to a more internal one, expressed in the concept "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildung")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n122",
      "id": "n122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" There will be a great deal to say about Bildung in this book. Difficult to translate, in essence it refers to the inner development of the individual, a process of fulfillment through education and knowledge, in effect a secular search "), _c('a', {
    attrs: {
      "id": "page78"
    }
  }, [_vm._v("for perfection, representing progress and refinement both in knowledge and in moral terms, an amalgam of wisdom and self-realization.")])]), _c('a', {
    attrs: {
      "id": "page78"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page78"
    }
  }, [_vm._v("Together, Halle and Göttingen helped to fashion a new kind of education that prepared the way for a new stratum in German society, which will require not a little attention. This stratum, too small to be a class, in Tim Blanning’s words, nevertheless achieved a prominent position in Germany by means of its domination of the state bureaucracy, the church, the military, the professoriate, and the professions. The self-understanding of this new stratum, which more than any other group helped account for the revival of German culture, set it apart from the traditional, more commercial middle classes."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n123",
      "id": "n123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" The progressive, rationalizing, meritocratic, and statist social vision that this new stratum brought to these institutions influenced the entire sweep of nineteenth-century history."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n124",
      "id": "n124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" In the early part of the century, in the words of Thomas Howard, it even worked toward the establishment of a particular kind of state, “one often described as a culture state ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kulturstaat")]), _vm._v(") or tutelary state ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Erziehungsstaat")]), _vm._v("), a state that numbered among its paternalistic duties the goal of inspiring and educating its people to become ‘appropriate citizens’…who understood that their aspirations should coincide with the high and morally serious purposes of the emergent nation-state.” After 1871, says Howard, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kulturprotestantismus")]), _vm._v("” or “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungsprotestantismus")]), _vm._v("” functioned as the “civil-religious foundation” of the German empire."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n125",
      "id": "n125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("An important observation comes out of all this: the German intelligentsia differed sharply from its counterparts in other countries. In France, the intelligentsia became estranged from the royal regime, so much so that it eventually attacked the traditional authorities. In Russia the intelligentsia consisted almost entirely of nobles, and in Britain neither the term nor the concept existed until the twentieth century. In Germany, because a university education was needed for a government position, the intelligentsia was drawn from all social levels. Not irrelevant either was the fact that Germany at that time lacked a metropolitan capital to rival London or Paris. This left the German intelligentsia dispersed yet far more intimately involved in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("practical")]), _vm._v(" state administration than anywhere else. Whereas British and American sociologists have characterized “remoteness from the practical world of government and administration” as "), _c('a', {
    attrs: {
      "id": "page79"
    }
  }, [_vm._v("one of the identifying features of the intelligentsia, this is manifestly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" true of Germany."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n126",
      "id": "n126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EADING")]), _vm._v(" R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EVOLUTION, A")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EW")]), _vm._v(" P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("UBLIC")]), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("PACE AND")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ATIONALISM")]), _vm._v(" E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("MERGING")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As late as May 1775 Christian Schubart reported in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutsche Chronik")]), _vm._v(" (German Chronicle) an encounter with a Neapolitan lady who was, he said, “under the impression” that “Germany must be a large city.” No less vividly, Joseph von Sonnenfels, one of the most distinguished figures of the Austrian Enlightenment, said this in a letter: “It is well-known how the French are accustomed to speaking and writing with unseemly contempt about German traditions, intellect, society, taste and everything else that blossoms under the German sun. Their adjectives ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tudesque")]), _vm._v(",’ ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("germanique")]), _vm._v(",’ and ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("allemande")]), _vm._v("’ are for them synonyms for ‘coarse,’ ‘ponderous’ and ‘uncultivated.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n127",
      "id": "n127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been true, in the late seventeenth and the early eighteenth centuries, that most educated Germans regarded French literary and artistic culture as superior to their own, and that British political freedoms and parliamentary practices were likewise to be envied. But that was before the changes introduced by Pietism and the country’s various rulers had taken hold and the universities had undergone their radical transformation. In that same period a number of economic, political, social, and intellectual changes had occurred in Europe that impacted disproportionately on German speakers and helped ensure that, before the eighteenth century was out, German culture had caught up with French and British achievements—and in some areas had outstripped them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n128",
      "id": "n128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The first was the reading revolution. This had partly to do with the gradual removal—or lightening—of censorship, harder to enforce in Germany because of its many different self-governing states, and is seen in both the anecdotal and statistical evidence. One account, written in the late eighteenth century, reads: “In no country is the love of reading more widespread than in Germany, and at no time was it more so than at present…The works of good and bad writers are now to be found in the apartments of princes and alongside the weaver’s loom, and, so as not to "), _c('a', {
    attrs: {
      "id": "page80"
    }
  }, [_vm._v("appear uncultivated, the upper classes of the nation decorate their rooms with books rather than tapestries.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n129",
      "id": "n129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Robert Darnton has shown that although book publishing suffered drastically after the Thirty Years’ War, by 1764 the Leipzig catalog of new books had regained its prewar level of about 1,200 new titles a year; by 1770 (when Georg Wilhelm Friedrich Hegel and Friedrich Hölderlin were born) it had grown to 1,600 and by 1800 to 5,000. Reading was also encouraged by another phenomenon of the eighteenth century—the lending library, which put a limit on the time a reader had access to any particular title. By 1800 there were nine lending libraries in Leipzig, ten in Bremen, and eighteen in Frankfurt am Main. Jürgen Habermas tells us that, by the end of the eighteenth century, there were 270 reading societies in Germany and some described a new illness, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lesesucht")]), _vm._v(", or “reading addiction.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n130",
      "id": "n130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Literacy rates in Prussia and Saxony in the early nineteenth century were unmatched anywhere except New England."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n131",
      "id": "n131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("An associated factor was the increased use of the vernacular language. “It was in the eighteenth century that the domination of the printed word by Latin was finally broken,” the percentage of titles published in Latin in Germany falling from 71 percent in 1600 to 38 percent in 1700 to 4 percent in 1800."), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_5",
      "id": "footnote5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n132",
      "id": "n132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" The same period also saw a marked shift in taste in Germany, with the proportion of theological titles dropping from 46 percent in 1625 to 6 percent in 1800, philosophy rising at the same time from 19 percent to 40 percent, and belles lettres up from 5 percent to 27 percent. Furthermore, the cultural decentralization of Germany, arising from its many political entities, made it—again in Tim Blanning’s words—“the land of the periodical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("par excellence")]), _vm._v(".”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n133",
      "id": "n133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Whereas the number of periodicals published in France rose from 15 in 1745 to 82 in 1785, the equivalent figures in Germany were 260 and 1,225 (of course many periodicals in France had higher circulations than those in Germany, but German periodicals also had wood-cut illustrations ahead of almost everywhere else). “[I]n Austria, the chief of police had to concede in 1806 that newspapers had become a ‘genuine necessity’ for the educated classes, anticipating Hegel’s celebrated remark that reading the daily newspaper "), _c('a', {
    attrs: {
      "id": "page81"
    }
  }, [_vm._v("represented the morning prayers of modern man.” The reading revolution brought with it a more critical approach to affairs, through the growth of “moral periodicals.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n134",
      "id": "n134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Not only was Germany becoming emancipated from Latin, its own language was developing. In 1700 the reputation of German had never been lower. In 1679, at the height of the French Sun King’s influence, Gottfried Leibniz (1646–1716) composed a pamphlet titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ermahnung an die Deutschen, ihren Verstand und ihre Sprache besser zu üben")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Exhortation to the Germans to Exercise Their Reason and Their Language Better")]), _vm._v("). Contrary to his usual practice, in his scientific and philosophical writings, which were written in Latin or French, this pamphlet was in German."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n135",
      "id": "n135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" The philosopher’s exhortation was taken seriously in a series of new periodicals, in particular one published in Zurich in the 1720s by a group of friends of whom Johann Jakob Bodmer (1698–1783) and Johann Jakob Breitinger (1701–76) were the leading spirits."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n136",
      "id": "n136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" This, known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Discourse der Mahlern")]), _vm._v(", was particularly concerned with the German language. Both Bodmer and Breitinger—after a few false starts—composed articles designed to make German a less ponderous language, more intimate, more pleasurable, and less like a sermon—a development that should, they claimed (and this was an important observation), have more appeal to women.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("These innovations were built on by others. At Halle, Christian Thomasius became the first German professor to deliver his lectures in German rather than in Latin."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n137",
      "id": "n137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Christoph Gottsched (1700–1766), a native of Königsberg, who moved to Leipzig and became professor of poetry and then of philosophy, formed a German society devoted to linguistic integrity: “At all times the purity and correctness of the language shall be promoted…only High German shall be written, not Silesian or Meissen, Franconian or Lower Saxon, so that it can be understood right across Germany.” German societies modeled on the Leipzig original were founded in several other cities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n138",
      "id": "n138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Gottsched also did his best to encourage the development of the novel and the drama. In the same way, in 1751 Christian Gellert published a popular treatise on letter writing, with the intention of encouraging young people, “especially women,” to cultivate a natural style of writing and of removing the “widespread misapprehension” that "), _c('a', {
    attrs: {
      "id": "page82"
    }
  }, [_vm._v("the German language was not supple and flexible enough “to treat of civilised matters and express tender emotions.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n139",
      "id": "n139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" Shortly afterward, the first epistolary novels in German began to appear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("A final effect of the reading revolution was on self-consciousness. Print-as-commodity, says Benedict Anderson, generates the “wholly new” idea of simultaneity, as people throughout society realize—via their reading—that others are going through the same experience, having the same thoughts, at the same time. “We are…at the point where communities of the type ‘horizontal-secular, transverse time’ become possible.” In this way public authority was consolidated, helped along by the depersonalized nature of state authority."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n140",
      "id": "n140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" These developments were more important than they might seem at first because it was these (vernacular) print languages, says Anderson, that laid the basis for nationalistic consciousness. Anderson’s conclusion is that print-capitalism operated on a variety of languages to create a new form of “imagined community,” setting the stage for the modern nation, in which a “national literature” was an important ingredient."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n141",
      "id": "n141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" In Johann Wolfgang von Goethe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Götz von Berlichingen mit der eisernen Hand")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Götz von Berlichingen with the Iron Hand")]), _vm._v("), a play about liberty, which describes the decline and fall of an Imperial Knight, the author himself said that the theme of the play was “Germanness emerging” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deutschheit emergiert")]), _vm._v(")."), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_6",
      "id": "footnote6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" In the nineteenth century, says Thomas Nipperdey, all this would lead to Germany becoming “the land of schools.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("However much they proliferated in the eighteenth century, novels, newspapers, periodicals, and letters had all existed in some form in the past. At the same time an entirely new cultural and intellectual medium emerged in the field of music: the public concert. By 1800 it had replaced all other forms of the art and become “the main medium for music "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("per se")]), _vm._v(".”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n142",
      "id": "n142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Furthermore, because the concert took place outside the princely or ecclesiastical courts, composers were free to invent their own musical forms and compositions. “The result was the conquest of the musical world by the symphony, the symphony concert, and the concert hall. This appar"), _c('a', {
    attrs: {
      "id": "page83"
    }
  }, [_vm._v("ently natural progression has led many historians to present the rise of the concert as the cultural equivalent of the French Revolution, in which the rising bourgeoisie tore down the barriers and fences which had reserved cultural goods for the feudal elite.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n143",
      "id": "n143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" This change boosted the sale of instruments and sheet music and the opportunities for music teachers, stimulating a virtuous cycle of which Germany as a whole would be the main beneficiary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The practice grew up in the first quarter of the eighteenth century for musicians to frequent the music rooms of inns, and it was these gatherings that eventually evolved into more formal concerts. Blanning says this took place in particular in Frankfurt am Main, Hamburg, Lübeck, and Leipzig and that what these four cities had in common was their commercial character, a factor which links the rise of concerts with the rise of the bourgeoisie. Concert halls proliferated as never before in the 1780s.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("All this refers to musical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("consumption")]), _vm._v(". Musical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("innovation")]), _vm._v(", on the other hand, innovation in instrumental music, and in particular the symphonic form, occurred in Mannheim, Eisenstadt, Salzburg, Berlin, and Vienna, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("residential")]), _vm._v(" cities centered on the courts, where such public as existed consisted mainly of state employees, mostly nobles rather than “bourgeois.” The high educational level of the Viennese nobles, musically speaking, made them particularly receptive to innovation. This, argues Blanning, helps account for the speed with which Franz Joseph Haydn, Wolfgang Amadeus Mozart, and Ludwig van Beethoven evolved the different forms of their art. In 1784, in the thirty-seven days between February 26 and April 3, Mozart played twenty-two benefits in Vienna."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n144",
      "id": "n144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" The sheer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quantity")]), _vm._v(" of music helped the evolution of new forms, as innovation was demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The symphony—purely instrumental music—was seen as a particularly German art form at the turn of the nineteenth century. Immanuel Kant had dismissed instrumental music—music without voices, without words—as simply pleasure, a form of “wallpaper,” not culture. But, as we shall see in Chapter 6, the rise of the symphony brought about a new way of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("listening")]), _vm._v(" to music, as people began to think of instrumental music as having great philosophical depth. A final factor was the performance of sacred texts in the vernacular, accompanied by music, a practice that had spread in the first place to Catholic Austria from Italy. In Protestant Ger"), _c('a', {
    attrs: {
      "id": "page84"
    }
  }, [_vm._v("many it was adapted to the Lutheran tradition of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("historia")]), _vm._v(", in which biblical stories were set to music (Georg Friedrich Handel’s oratorios in particular). The importance of the genre was that it made public music making "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("respectable")]), _vm._v(". “The oratorio was edifying, lending itself admirably to the raising of money for charity, so it overcame the old association of listening to music in public with ale-house ‘musique rooms’ or dance halls…Here is seen the beginning of a phenomenon that is very much still with us: the sacralization of art.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n145",
      "id": "n145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("And so, just as the German language was developing and reading and educational standards were rising, music also helped to change the image of the Germans as backward in cultural matters. The proliferation of distinguished composers could not be ignored, as the names of Johann Pachelbel (1653–1706), Georg Philipp Telemann (1681–1767), Johann Sebastian Bach (1685–1750), and Georg Friedrich Handel (1685–1759) confirm. Tim Blanning quotes a periodical published in 1741 in Brunswick, titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Der musikalische Patriot")]), _vm._v(" (The Musical Patriot), which boasted: “Must not the Italians, who previously were the tutors of the Germans, now envy Germany its estimable composers, and secretly seek to learn from them? Indeed, must not the high and mighty Parisians, who used to deride German talent as something provincial, now take lessons from Telemann in Hamburg?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n146",
      "id": "n146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ERMAN")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OSES")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("A quite separate factor specific to Germany, which helped finalize its transformation into a great political and cultural power in Europe, was another king, Friedrich Wilhelm I’s son, Friedrich the Great. The generally accepted view of Friedrich, now, is that he was a divided soul, devoted on the one hand to monarchical autocracy, yet at the same time a lifelong admirer of John Locke, who at least in theory favored liberalism for its cultural and political freedoms. In reality, this division within Friedrich did no more than reflect the evolving politics of the eighteenth century. His was a conservative administration in comparison with the political systems then in existence elsewhere in Europe and in North America, reflecting above all the German idea that freedom and equality could best "), _c('a', {
    attrs: {
      "id": "page85"
    }
  }, [_vm._v("be achieved under conditions of order, such order being maintained by an established authority, in the person of the monarch.")])]), _c('a', {
    attrs: {
      "id": "page85"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page85"
    }
  }, [_vm._v("Although he was a conservative by European standards, Friedrich did bring about great change. After his accession in 1740, his many battlefield successes (achieved because of the strength and excellence of the army he inherited from his father, built up still further by him), combined with other civic reforms, completed Prussia’s great transformation into Germany’s foremost state and one of Europe’s great powers."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n147",
      "id": "n147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Friedrich’s mother, Sophie Dorothea, was a Hanoverian princess whose brother was King George II of England. Her husband’s Pietist, masculine world, effective though it was, was not by any means to her taste and she was anxious lest it smother her children. Friedrich’s education was placed first in the hands of Huguenot soldiers, who introduced him to mathematics, economics, Prussian law, and modern history but also to fortification, tactics, and the other arts of war. His mother nevertheless insisted he be given his own library of several thousand books. As a result, even in his teens Friedrich became familiar with the leading French, English, and German writers (in more or less that order)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n148",
      "id": "n148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("As soon as he became king, he set up an Academy of Arts and Sciences in Berlin. Directed by a distinguished French mathematician, Pierre de Maupertuis, one aim of the academy was to attract to Berlin the best minds, who would form a learned circle around Friedrich. Day-to-day government was run from the Charlottenburg Palace on the outskirts of Berlin, while Friedrich’s circle of intellectuals met at Sans Souci, a specially built retreat in an area of lakes southwest of Berlin in Potsdam. Here the king entertained and argued with great minds such as Voltaire and Jean le Rond d’Alembert, one of the editors of the multivolume French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Encyclopédie")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n149",
      "id": "n149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" Five copies were bought of every book that Friedrich wished to read, since he possessed identical libraries at Potsdam, Sans Souci, Charlottenburg, Berlin, and Breslau."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n150",
      "id": "n150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Amazingly, to our modern way of thinking, the Prussian king and his courtiers always spoke French to one another (Voltaire wrote home that he never heard German spoken at court)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n151",
      "id": "n151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" Friedrich shunned his native tongue as “barbaric,” feeling its literary time had not yet arrived. In 1780 he went so far as to publicly criticize the German language in a "), _c('a', {
    attrs: {
      "id": "page86"
    }
  }, [_vm._v("pamphlet and admitted that the German books he wanted to read must be translated into French first. This was a man whose own writings included poetry, political and military tracts, philosophical treatises, and hundreds—if not thousands—of letters exchanged with leading intellectuals (645 letters with Voltaire alone, spanning forty-two years and filling three volumes)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n152",
      "id": "n152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Friedrich was, nevertheless, unable to appreciate great swaths of contemporary culture. He was, for example, ignorant of Mozart and dismissed Haydn’s music as “a shindig that flays the ears.” He complained to Voltaire in 1775, the year after Goethe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Leiden des jungen Werthers")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Sufferings of Young Werther")]), _vm._v(") was published, that German literature was nothing more than a “farrago of inflated phrases.” He despised new forms—the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("drama bourgeois")]), _vm._v(", for instance—and he equally loathed ancient German epics such as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nibelungenlied")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n153",
      "id": "n153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" In his notorious 1780 essay, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Concerning German Literature; the faults of which it can be accused; the causes of the same and the means of rectifying them")]), _vm._v(", Friedrich argued that in material terms Germany was flourishing, having recovered finally from the ravages of the Thirty Years’ War, but that its culture was still suffering. What was needed now, he argued, was geniuses, but until they revealed themselves Germans must continue to rely on translations from classical and French authors. Friedrich thought that Germany’s cultural level was about two-and-a-half centuries behind that of France. “I am like Moses, I see the promised land from afar, but shall not enter it myself.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n154",
      "id": "n154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Despite Friedrich’s pessimism, many German artists and intellectuals were convinced that it was the king’s forging of Great-Power status for Prussia that had given German culture the decisive kick-start. Goethe even thought that the widespread infiltration of French culture into Prussia, through Friedrich’s tastes, was “highly beneficial” for Germans, spurring them on by provoking a reaction. Many others agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Then there was the fact that Friedrich, like no other king before him and few since, entered the public sphere. As Goethe was sharp enough to notice, by simply publishing a pamphlet about German literature, Friedrich gave intellectual debate a momentum that no other living person could have matched."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n155",
      "id": "n155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Moreover, he encouraged others to enter the public sphere in a critical spirit by having the Academy organize annual prize-essay competitions, setting such ambitious questions as: “What has been "), _c('a', {
    attrs: {
      "id": "page87"
    }
  }, [_vm._v("the influence of governments on culture in nations where it has flourished?” (won by Johann Gottfried von Herder), “Can it be expedient to deceive the people?” and “What has made French the universal language of Europe and does it deserve this supremacy?”")])]), _c('a', {
    attrs: {
      "id": "page87"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page87"
    }
  }, [_vm._v("These paradoxical achievements in the literary/intellectual world were matched in the military/political sphere. Through Friedrich’s many battle successes, Prussia became a major European power, a status it maintained (other than 1806–13 if we are being finicky) until World War I. His victories were followed by initiatives in other realms of government: an agency dedicated to strategic economic development, greater freedom of the press, a reduction in the number of capital crimes, and advanced codification of Prussian law. He insisted that education become compulsory for all and urged (some) religious toleration. “So far did a new middle class and civil society advance by the end of Friedrich’s reign that German intellectuals could look on the revolutions in America and France as belated efforts to catch up with Prussia.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n156",
      "id": "n156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Friedrich’s forty-six-year rule undoubtedly helped Prussia’s rise to power and, culturally and intellectually speaking, between Bach’s death in 1750 and Friedrich’s own in 1786, Germany without question witnessed the stirrings of its own renaissance, a rival even of the Italian Renaissance of the fourteenth to sixteenth centuries.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page88"
    }
  })]), _c('a', {
    attrs: {
      "id": "page88"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page88"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc05e4d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062018465_Chapter_1.vue
// module id = 75
// module chunks = 0